import { render } from "./VouchersPrint.vue?vue&type=template&id=0f35205c&scoped=true"
import script from "./VouchersPrint.vue?vue&type=script&lang=js"
export * from "./VouchersPrint.vue?vue&type=script&lang=js"

import "./VouchersPrint.vue?vue&type=style&index=0&id=0f35205c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f35205c"]])

export default __exports__